/*
 * @Author: 侯鹏许
 * @Email: houpengxu@qq.com
 * @Date: 2021-03-12 10:23:11
 * @LastEditTime: 2021-03-25 17:21:58
 * @LastEditors: 侯鹏许
 * @Description: 
 * @FilePath: /yq-rs-make-wxwork/src/views/car/utils.js
 */
import qs from 'querystring'
import store from "../../store"
import wxsdk from "@/utils/wxsdk";
/**
 * 对象深拷贝
 * @param {Object} source
 * @returns {Object} 新对象
 */
export function deepClone(source) {
    if (!source && typeof source !== 'object') {
      throw new Error('error arguments', 'deepClone')
    }
    const targetObj = source.constructor === Array ? [] : {}
    Object.keys(source).forEach(keys => {
      if (source[keys] && typeof source[keys] === 'object') {
        targetObj[keys] = deepClone(source[keys])
      } else {
        targetObj[keys] = source[keys]
      }
    })
    return targetObj
  }
/**
 * H5&小程序页面跳转
 * @param {string} path 跳转路径
 * @param {boolean} openInMp 是否小程序打开
 */
export function navigateTo(path, openInMp = true){
  const { origin } = window.location
  let targetUri = origin + path, //目标跳转完整地址
  params = qs.parse(path.split('?')[1] || ""),//当前uri携带参数
  {shareSpreadInfo, isInMiniProgram} = store.state //传僠相关参数
  const { refereeopenid, rscuid, entry, id, psn } = shareSpreadInfo
  if(/^\/h5\/t13.+/.test(path)){//当前页为首页
    targetUri += '&' + qs.stringify({refereeopenid, rscuid})
  }else if(/^\/h5\/t12.+/.test(path)){
    targetUri += '&' + qs.stringify({refereeopenid, rscuid, entry, t9id: id, t9psn: psn})
  }else{
     targetUri = origin + path.split('?')[0] + '?' + qs.stringify({...shareSpreadInfo, ...params})
  }
  if(isInMiniProgram && openInMp){
    wxsdk.wx.miniProgram.navigateTo({
      url: `/pages/webview/common/common?url=${encodeURIComponent(targetUri)}`
    });
  }else{
    window.location.href = targetUri
  }


}